/**
 * OrderItem.options JSON을 사람이 읽을 수 있는 문자열 배열로 변환
 */
export function formatItemOptions(options: Record<string, unknown>): string[] {
  if (!options || typeof options !== 'object') return [];
  const parts: string[] = [];

  // Plus 옵션 (사이즈/타입)
  const plusValue = options.plusValue;
  if (plusValue != null) {
    if (Array.isArray(plusValue)) {
      // multi-range: [120, 60] → "120 x 60"
      parts.push((plusValue as number[]).join(' x '));
    } else if (typeof plusValue === 'number') {
      parts.push(String(plusValue));
    } else if (typeof plusValue === 'string' && plusValue) {
      parts.push(plusValue);
    }
  }

  // Auto 규격 (auto_weight / auto_volume)
  const autoWeightKg = options.autoWeightKg;
  if (typeof autoWeightKg === 'number' && autoWeightKg > 0) {
    parts.push(`무게 ${autoWeightKg}kg`);
  }

  const w = options.autoWidthMm;
  const d = options.autoDepthMm;
  const h = options.autoHeightMm;
  if (typeof w === 'number' && typeof d === 'number' && typeof h === 'number') {
    parts.push(`${Math.round(w / 10)}x${Math.round(d / 10)}x${Math.round(h / 10)}cm`);
  }

  // Extra 옵션 (집안 수거, 집안 배송 등)
  const extraValue = options.extraValue;
  if (Array.isArray(extraValue) && extraValue.length > 0) {
    parts.push(...(extraValue as string[]));
  }

  // 균일가 물품 설명
  const itemDescription = options.itemDescription;
  if (typeof itemDescription === 'string' && itemDescription) {
    parts.push(itemDescription);
  }

  return parts;
}

export function formatItemOptionsCompact(options: Record<string, unknown>): string {
  return formatItemOptions(options).join(', ');
}
